import { render, staticRenderFns } from "./VideoMeeting.vue?vue&type=template&id=4ea406a4"
import script from "./VideoMeeting.vue?vue&type=script&lang=js"
export * from "./VideoMeeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports